export enum Language {
  ENGLISH = "en",
  SPANISH = "es",
  ITALIAN = "it",
  PORTUGUESE = "pt",
}

export enum Locale {
  EN = "en-GB",
  ES = "es-ES",
  IT = "it-IT",
  PT = "pt-BR",
}
